//  Company Service - Handles API interactions for Comany management

import { post, get,put } from "../utils/apiUtils";


// No need to use BASE_URL as it's already configured in apiUtils.js
const API_URL = `/api/v1/mms_authentication/create_company`;
const BASE_COMPANY_URL = `/api/v1/mms_persistence/company`;

/**
 * Get all claims Oauths
 * @param {any} domainName - Fetch for what domain
 * @returns {Promise<Object>} Promise resolving to Oauth listing
 */
export const saveCompany = async (payload) => {
  try {
    const response = await post(`${API_URL}`, payload);
    return response;
  } catch (error) {
    console.error('Error saving company:', error);
    throw error;
  }
};

export const updateCompany = async (payload) => {
  try {
    const response = await put(`${BASE_COMPANY_URL}`, payload);
    return response;
  } catch (error) {
    console.error('Error saving company:', error);
    throw error;
  }
};

const companyCache = new Map();

const generateCacheKey = (filter, sort, query) => {
  return JSON.stringify({ filter, sort, query });
};

/**
 * Get all claims Oauths
 * @param {any} domainName - Fetch for what domain
 * @returns {Promise<Object>} Promise resolving to Oauth listing
 */
export const getCompaniesByFilter = async (filter = {}, sort ={}, query =null) => {
  const cacheKey = generateCacheKey(filter, sort, query);
  
  if (companyCache.has(cacheKey)) {
    console.log('Returning cached companies');
    return companyCache.get(cacheKey);
  }
  
  try {
    const response = await post(`${BASE_COMPANY_URL}/fetch?${query}`, { filter: filter,sort });
    companyCache.set(cacheKey, response);
    return response;
  } catch (error) {
    console.error('Error fetching companies:', error);
    throw error;
  }
};

export const clearCompanyCache = () => {
  companyCache.clear();
};

export default {
    saveCompany, updateCompany
}
